import { store } from "@/store/store";
import axios from "axios";

export default function fetchPeriodicImages(empresa) {
  let interval;

  const getImages = async () => {
    axios({
      method: "post",
      url: `${process.env.VUE_APP_APIURL}/imagesDelivery/getdata`,
      data: {
        empresa: empresa,
      },
    })
      .then((res) => {
        store.commit("incrementImages", res.data);
        if (res.data.length > 0) {
          store.commit("incrementBanner", true);
        }
        return res.data;
      })
      .catch(() => {
        clearInterval(interval);
      });
  };

  const INTERVAL_MS = 60000; // set the interval in minutes

  const executeFunction = () => {
    getImages();
  };

  interval = setInterval(() => {
    executeFunction();
  }, INTERVAL_MS);

  executeFunction(); // initial execute
}
